import React from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";

export const SuprLoc = ({
  setSuprLoc,
  idSelected,
  stockageALibrerer,
  onClose,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const handleConfirm = () => {
    try {
      axios
        .post(`${apiUrl}IHM/api/location.php?idSupr=${idSelected}`)

        .then((response) => {
          console.log("okey, suprimé");
          console.log(response);
          libererStockage();
          toast.success(`Location n° ${idSelected} supprimée avec succès!`, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setSuprLoc(false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("  error");
    }
  };
  const libererStockage = () => {
    try {
      // libererLastStkg
      axios
        .post(`${apiUrl}IHM/api/stockage.php?idSliberer=${stockageALibrerer}`)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Erreur lors de la requête Axios : ", error);
        });
    } catch (error) {
      console.log("AIZAEEE error");
    }
  };
  const handleCancel = () => {
    toast.error(`Suppression de la location n° ${idSelected} annulée!`, {
      position: toast.POSITION.TOP_RIGHT,
    });
    setSuprLoc(false);
    if (typeof onClose === "function") {
      onClose(); // Appel de la fonction de rappel , manao mise à jour atsy
      console.log("OnClose");
    }
  };
  return (
    <div>
      <div>
        <div className="modalContainerSupr" style={{ textAlign: "center" }}>
          <p>
            Voulez-vous vraiment supprimer la location numero {idSelected} ?
          </p>
          <Button
            variant="contained"
            color="secondary"
            style={{ margin: "10px" }}
            onClick={handleConfirm}
          >
            Oui
          </Button>{" "}
          <Button
            variant="contained"
            color="primary"
            style={{ margin: "10px" }}
            onClick={handleCancel}
          >
            Non
          </Button>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};
